module.exports = __webpack_public_path__ + "static/media/jesus.1ba4601b.jpg";